function addPreloadImageTag(imageSrc: string) {
  const firstScript = window.document.getElementsByTagName('script')[0]
  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'image'
  link.setAttribute('fetchpriority', 'high')
  link.href = imageSrc
  link.type = 'image/webp'
  firstScript.parentNode?.insertBefore(link, firstScript)
}

export function usePreloadImage(imageSrc: string | undefined) {
  if (document.querySelector(`link[rel='preload'][href="${imageSrc}"]`)) {
    return
  }
  if (imageSrc) {
    addPreloadImageTag(imageSrc)
  }
}
